<template>
<div id="index">
  <div  id="runTaskDiv" v-html="errorInfo">
   
  </div>

</div>
</template>
<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'


export default {
  data () {
    return {
      webConfigInfo:{},
      paramInfo:{},
      yellowPage:"",
      footerColumnInfos:[],
      warehousingUrl:"",
      navigationColumnInfos:[],
      hitSearchUrl:'',
      enterpriseResourceBaseUrl:'',
      yellowPageColumn:{},
      productAndSolutionColumn:{},
      loading:true,
      runRecuritUrl:'',
      noticeInfo:[],
      showMessage:'',
      loginFlag:false,
      redirectUrl:'',
      userInfo:{},
      companyInfo:{},
      messageNumber:'',
      redirectURL:'',
      responseInfo:{},
      showFlag:false,
      hiddenContent:'',
      currentResponseInfo:{},
      userName:'',
      email:'',
      mobile:'',
      hiddenTrueName:'',
      hiddenEmail:'',
      hiddenMobile:'',
      currentUserInfo:{},
      errorInfo:'',
      code:'',
      backUrl:'',
      openId:'',
      wechatUrl:'',
      password:"",
      rememeberPassword:false,
      checkFlag:false,
      accountInfo:{},
      rememberInfo:{},
      loginUser:'',
      loginPass:'',
      regeisterType:'',
      checkCardInfo:{},
      userTag:'',
      isCompanyManager:false,
      verrifyCodeUrl:'',
      verifyCode:'',
      verifyCodeExt:'',
      checkVerifyFlag:false,
      loginFailNumber:0,
      openId:'',
      coordinationSupplierAuthFlag:false,
      coordinationSystemAuthFlag:false,
      supplierManagerAuthFlag:false


    }
  },
  computed: mapState([
    'KP'
  ]),
  created () {
    let query = this.$route.query;
    this.code = query.code;
    this.backUrl = query.backUrl;
    this.wechatUrl = query.wechatUrl;
    this.$axios.post('/onelink.mdata.main.api/thirdPartyLogin/wechatAppLogin?code='+this.code+'&backUrl='+this.backUrl+"&wechatUrl="+this.wechatUrl, {
        }).then((res) => {
        this.data = res.data;
        this.loginFlag = this.data.loginFlag;
        this.userInfo =this.data.uCenterMemberInforDto;
        this.userTag = this.userInfo.userTag;
        this.companyInfo = this.data.uCenterMemberInforDto.uCenterORGUserRelationsDto;
        this.messageNumber = this.data.messageNumber;
        this.regeisterType =this.data.registerType;
        this.checkFlag = this.data.checkFlag;
        this.checkCardInfo = this.data.checkCardInfo;
        this.isCompanyManager = this.data.isCompanyManager;
        this.loginFailNumber = this.data.loginFailNumber;
        this.coordinationSupplierAuthFlag = this.data.coordinationSupplierAuthFlag;
        this.coordinationSystemAuthFlag = this.data.coordinationSystemAuthFlag;
        this.supplierManagerAuthFlag = this.data.supplierManagerAuthFlag;
        this.noticeInfos = this.data.noticeInfos;
        this.redirectURL = this.data.redirectUrl;
        Cookies.set('companyName',this.userInfo.companyName,{domain:'.onelinkplus.com',expires:10 });
        this.setToken('regeisterType',this.regeisterType)
        Cookies.set('regeisterType',this.regeisterType,{domain:'.onelinkplus.com',expires:10 });
        this.setToken('noticeInfos',JSON.stringify(this.noticeInfos))
        this.setToken('loginFailNumber',this.loginFailNumber)
        this.setToken('userTag',this.userTag);
        if(this.isCompanyManager){
          this.setToken('isCompanyManager',100);
          Cookies.set('isCompanyManager',100,{domain:'.onelinkplus.com',expires:10 });
        }else{
          this.setToken('isCompanyManager','');
          Cookies.set('isCompanyManager','',{domain:'.onelinkplus.com',expires:10});
        }
        if(Number(this.messageNumber) > 99){
          this.messageNumber = '99+';
        }else{
          this.messageNumber = this.messageNumber;
        }
        this.accountInfo.userName = this.userName;
        this.accountInfo.password = this.password;
        this.openId = this.data.openId;
        if(this.loginFlag){
          
          if(this.coordinationSupplierAuthFlag){
                this.setToken('coordinationSupplierAuthFlag','100');
                Cookies.set('coordinationSupplierAuthFlag','100',{domain:'.onelinkplus.com',expires:10});
              }else{
                this.setToken('coordinationSupplierAuthFlag','200');
                Cookies.set('coordinationSupplierAuthFlag','200',{domain:'.onelinkplus.com',expires:10});
              }
              if(this.coordinationSystemAuthFlag){
                this.setToken('coordinationSystemAuthFlag','100')
                Cookies.set('coordinationSystemAuthFlag','100',{domain:'.onelinkplus.com',expires:10});
              }else{
                this.setToken('coordinationSystemAuthFlag','200')
                Cookies.set('coordinationSystemAuthFlag','200',{domain:'.onelinkplus.com',expires:10});
              }
                if(this.supplierManagerAuthFlag){
                  this.setToken('supplierManagerAuthFlag','100')
                  Cookies.set('supplierManagerAuthFlag','100',{domain:'.onelinkplus.com',expires:10});
                }else{
                  this.setToken('supplierManagerAuthFlag','200')
                  Cookies.set('supplierManagerAuthFlag','200',{domain:'.onelinkplus.com',expires:10});

                }
              
              //设置本地存储及vuex仓库中islogin的状态值
              this.setToken('isLogin',100);
              Cookies.set('isLogin',100,{domain:'.onelinkplus.com',expires:10});
              if(this.checkFlag){
                this.setToken('checkFlag',100);
                Cookies.set('checkFlag',100,{domain:'.onelinkplus.com',expires:10});
              }else{
                this.setToken('checkFlag',200);
                Cookies.set('checkFlag',200,{domain:'.onelinkplus.com',expires:10});
              }
              
              this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
              this.setToken('companyInfo',this.getAesString(JSON.stringify(this.companyInfo),this.KP.key,this.KP.iv));
              this.setToken('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv));
              this.setToken('accountInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));
              
              Cookies.set('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
              if(this.rememeberPassword){
                this.setToken('isRemember',100);
                this.setToken('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});

                Cookies.set('isRemember',100);
                Cookies.set('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
              }else{
                this.setToken('isRemember','');

                Cookies.set('isRemember','',{domain:'.onelinkplus.com',expires:10});
              }
                this.setToken('examineStatus','');
                Cookies.set('examineStatus','',{domain:'.onelinkplus.com',expires:10});
                this.setToken('exmaineMessage','');
                Cookies.set('exmaineMessage','',{domain:'.onelinkplus.com',expires:10});
              if(this.redirectURL =='' || typeof(this.redirectURL) == "undefined"){
                if(this.userTag == '20'){
                  this.$router.push({path:'/purchaser'});
                }else if(this.userTag == '10'){
                  this.$router.push({path:'/supplier',query:{shortcutMenu:'10'}});
                }else{
                  this.$router.push({path:"/"});
                }
                
              }else{
                  if(this.redirectURL.indexOf('http') == 0){
                    window.location.href = this.redirectURL;
                  }else{
                  this.$router.push({path:this.redirectURL});
                  }
                // window.location.href = this.redirectURL;
              }
        }else{
          if(this.rememeberPassword){
                this.setToken('isRemember',100);
                this.setToken('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));

                Cookies.set('isRemember',100,{domain:'.onelinkplus.com',expires:10});
                Cookies.set('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
              }else{
                this.setToken('isRemember','');

                Cookies.set('isRemember','',{domain:'.onelinkplus.com',expires:10});
              }
          if(this.data.errorInfo == '该账户正在审核中'){
            this.setToken('examineStatus',200);

                Cookies.set('examineStatus',200,{domain:'.onelinkplus.com',expires:10});
                this.setToken('isLogin',100);
                this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
                this.setToken('companyInfo',this.getAesString(JSON.stringify(this.companyInfo),this.KP.key,this.KP.iv));
                this.setToken('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv));
                this.setToken('accountInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));

                Cookies.set('isLogin',100,{domain:'.onelinkplus.com',expires:10});
                Cookies.set('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
                this.$router.push({path:"registerExamine",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName,createUserId:this.userInfo.createUserId}});
          }else if(this.data.errorInfo == '该账户审批未通过'){
            this.setToken('examineStatus',300);
                this.setToken('exmaineMessage',this.checkCardInfo.checkRemark);

                Cookies.set('examineStatus',300,{domain:'.onelinkplus.com',expires:10});
                Cookies.set('exmaineMessage',this.checkCardInfo.checkRemark,{domain:'.onelinkplus.com',expires:10});
                this.setToken('isLogin',100);
                this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
                this.setToken('companyInfo',this.getAesString(JSON.stringify(this.companyInfo),this.KP.key,this.KP.iv));
                this.setToken('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv));
                this.setToken('accountInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));

                Cookies.set('isLogin',100,{domain:'.onelinkplus.com',expires:10});
                Cookies.set('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
                this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.regeisterType,exmaineMessage:this.checkCardInfo.checkRemark,createUserId:this.userInfo.createUserId}});
          }else{
            this.$router.push({path:"/login",query:{openId:this.openId,redirectURL:this.redirectURL}})
          }
        
      }
    }).catch((err) => {
    console.log(err)
  })
   
    //   alert(JSON.stringify(user));
       
    

    
  },
  methods:{
    jump(url){
      window.location.href = url;
    }
  }
}
</script>

<style scoped lang="stylus">
@media only screen and (max-width: 766px)
  .games
    display: none
</style>



// WEBPACK FOOTER //
// src/pages/callBack/index.vue